// MultiMultibuttonCustom

import React, { Component } from "react";
import { Button } from "reactstrap";
import { UncontrolledTooltip } from "reactstrap";
import ModalArea from '../ModalArea';
import { async } from 'q';
import { fetchData } from "../common/networkRequests";
import { generateOtherValues,setCookie } from "../oro-module/commonFunctions";
import { getObjectsValue } from "../../pages/commonFunctions";



class MultibuttonCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      modalProps: false,
      btnclicked: false,
      btnclass: {}
    };
  }

  generateID = () => {
    return this.state.ttid;
  };
  // generateOtherValues = (sendData) => {
  //   let { pageData, openmodals } = this.props.parentState;
  //   let returnVal = {}
  //   if (sendData.length != 0) {
  //     sendData.map(otherfield => {
  //       if (otherfield.varname) {
  //         returnVal[otherfield.varname] = getObjectsValue(pageData, otherfield.value);
  //       } else {
  //         returnVal[otherfield] = getObjectsValue(pageData, otherfield);
  //       }
  //     })
  //   }
  //   return returnVal
  // }

  // handleAppendModal = () => {
  //   let name = this.props.component.name;
  //   console.log("hi")
  //   this.setState({ modalProps: true });
  //   let om = this.props.parentState.openmodals;
  //   om.push(name + "_search");
  //   this.props.liftGlobalState({ name: "openmodals" }, om);

  // }

  liftControlsState = (stateName, stateValue) => {
    this.setState({ [stateName]: stateValue });
  }

  render() {
    let {
      name,
      Bcolor,
      style,
      size,
      label,
      buttonfocus,
      placeHolder,
      isRequired,
      description,
      Blocktype,
      options
    } = this.props.component;
    let { conditionalRender, parentState } = this.props;
    let { pageData } = parentState;
    const tooltipID = this.generateID();
    let classval = "";
    let classval1 = ""; let buttontype
    !style && (style = {})
    !size && (size = "sm")
    Blocktype === "block" && (classval = "btn-block")
    Bcolor ? (classval1 = Bcolor) : (classval1 = "info");
    // buttonfocus ? buttontype=buttonfocus 

    return (
      <div
        id={tooltipID}
        key={this.props.index}
        // style={style}
        className={`form-group ${this.props.component.widths.parent} row`}
      >
        {conditionalRender && conditionalRender != 'blank' &&
          this.props.component.options.map((val, index) => (
            <div key={index} className={`${val.width}`}
            >
              {pageData[name] == val.value &&
                <Button
                  size={size}
                  className={`${classval} col-sm-12`}
                  // disabled={this.state.btnclicked}
                  color={classval1}
                  onClick={() => this.props.liftState(this.props.component, val.value)}
                  style={style}
                >
                  {val.label}
                </Button>
              }
              {pageData[name] != val.value &&
                <Button
                  size={size}
                  outline
                  className={`${classval} col-sm-12`}
                  // disabled={this.state.btnclicked}
                  color={classval1}
                  onClick={() => this.props.liftState(this.props.component, val.value)}
                  style={style}
                >
                  {val.label}
                </Button>
              }
            </div>
          ))
        }
      </div>
    );
  }
}

export default MultibuttonCustom;
